export default __webpack_public_path__ + "static/media/undraw_under_construction_46pa.ea6db4b6.svg";